
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {SocialTradingAllocationMethod} from '../core/SocialTradingAllocationMethod';
import {FieldModelSocialTradingAllocationMethod} from '../core/SocialTradingAllocationMethod';

/**
 * SocialTradingMasterUpdate struct
 */
class SocialTradingMasterUpdate {
  /**
   * Initialize struct
   * @param {SocialTradingAllocationMethod=} allocationMethod
   * @param {number=} commissionLogin
   * @param {number=} feePercent
   * @constructor
   */
  constructor (allocationMethod = null, commissionLogin = null, feePercent = null) {
    this.AllocationMethod = allocationMethod
    this.CommissionLogin = commissionLogin
    this.FeePercent = feePercent
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingMasterUpdate}
   * @param {!SocialTradingMasterUpdate} other Other struct
   * @returns {!SocialTradingMasterUpdate} This struct
   */
  copy (other) {
    if (other.AllocationMethod != null) {
      this.AllocationMethod = SocialTradingAllocationMethod.fromObject(other.AllocationMethod)
    } else {
      this.AllocationMethod = null
    }
    if (other.CommissionLogin != null) {
      this.CommissionLogin = UInt64.fromNumber(other.CommissionLogin)
    } else {
      this.CommissionLogin = null
    }
    if (other.FeePercent != null) {
      this.FeePercent = other.FeePercent
    } else {
      this.FeePercent = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingMasterUpdate}
   * @returns {!SocialTradingMasterUpdate} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingMasterUpdateModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingMasterUpdateModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingMasterUpdate}
   * @param {!SocialTradingMasterUpdate} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingMasterUpdate)) {
      throw new TypeError('Instance of SocialTradingMasterUpdate is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingMasterUpdate}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      AllocationMethod: ((this.AllocationMethod != null) ? this.AllocationMethod : null),
      CommissionLogin: ((this.CommissionLogin != null) ? this.CommissionLogin.toNumber() : null),
      FeePercent: ((this.FeePercent != null) ? this.FeePercent : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingMasterUpdate.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingMasterUpdate} other Object value
   * @returns {!SocialTradingMasterUpdate} Created struct
   */
  static fromObject (other) {
    return new SocialTradingMasterUpdate().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingMasterUpdate}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingMasterUpdate.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingMasterUpdate}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6488
  }
}

export { SocialTradingMasterUpdate };

/**
 * Fast Binary Encoding SocialTradingMasterUpdate field model
 */
class FieldModelSocialTradingMasterUpdate extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.AllocationMethod = new fbe.FieldModelOptional(new FieldModelSocialTradingAllocationMethod(buffer, 4 + 4), buffer, 4 + 4)
    this.CommissionLogin = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize), buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize)
    this.FeePercent = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize), buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.AllocationMethod.fbeSize + this.CommissionLogin.fbeSize + this.FeePercent.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.AllocationMethod.fbeExtra + this.CommissionLogin.fbeExtra + this.FeePercent.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingMasterUpdate.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6488
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllocationMethod.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FeePercent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!SocialTradingMasterUpdate} fbeValue Default value, defaults is new SocialTradingMasterUpdate()
   * @returns {!SocialTradingMasterUpdate} SocialTradingMasterUpdate value
   */
  get (fbeValue = new SocialTradingMasterUpdate()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!SocialTradingMasterUpdate} fbeValue SocialTradingMasterUpdate value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) <= fbeStructSize) {
      fbeValue.AllocationMethod = this.AllocationMethod.get()
    } else {
      fbeValue.AllocationMethod = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionLogin = this.CommissionLogin.get()
    } else {
      fbeValue.CommissionLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) <= fbeStructSize) {
      fbeValue.FeePercent = this.FeePercent.get()
    } else {
      fbeValue.FeePercent = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {!SocialTradingMasterUpdate} fbeValue SocialTradingMasterUpdate value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingMasterUpdate}
   * @param {SocialTradingMasterUpdate} fbeValue SocialTradingMasterUpdate value
   */
  setFields (fbeValue) {
    this.AllocationMethod.set(fbeValue.AllocationMethod)
    this.CommissionLogin.set(fbeValue.CommissionLogin)
    this.FeePercent.set(fbeValue.FeePercent)
  }
}

export { FieldModelSocialTradingMasterUpdate };

/**
 * Fast Binary Encoding SocialTradingMasterUpdate model
 */
class SocialTradingMasterUpdateModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingMasterUpdate(this.buffer, 4)
  }

  /**
   * Get the SocialTradingMasterUpdate model
   * @this {!SocialTradingMasterUpdateModel}
   * @returns {!FieldModelSocialTradingMasterUpdate} model SocialTradingMasterUpdate model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingMasterUpdateModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingMasterUpdateModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingMasterUpdateModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingMasterUpdateModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingMasterUpdate.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingMasterUpdateModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingMasterUpdateModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingMasterUpdateModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingMasterUpdateModel}
   * @param {!SocialTradingMasterUpdate} value SocialTradingMasterUpdate value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingMasterUpdateModel}
   * @param {!SocialTradingMasterUpdate} value SocialTradingMasterUpdate value, defaults is new SocialTradingMasterUpdate()
   * @return {!object} Deserialized SocialTradingMasterUpdate value and its size
   */
  deserialize (value = new SocialTradingMasterUpdate()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingMasterUpdate(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingMasterUpdate(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingMasterUpdateModel}
   * @param {!number} prev Previous SocialTradingMasterUpdate model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingMasterUpdateModel };
